import firebase from '../../../firebase/firebase';
const firestore = firebase.firestore();

export default {

    namespaced: true,

    state: {
        reports: []
    },

    actions: {
        async fetchReportsInPeriod ({ commit, rootGetters }, { date }) {
            let daysRef = firestore.collection(`company/${rootGetters.getCompanyID}/counters/fiscal/daily`);
            if (date && date.from)
                daysRef = daysRef.where('date', '>=', date.from)
            if (date && date.to)
                daysRef = daysRef.where('date', '<=', date.to)
            const daysSnap = await daysRef.get();
            commit('setReports', daysSnap.docs.map(snap => ({ id: snap.id, ...snap.data() })));
        }
    },

    mutations: {
        setReports (state, values) {
            values.forEach(dailyReport => {
                Object.values(dailyReport.nfces).forEach(nfce => {
                    nfce.emmittedAt = new Date(nfce.emmittedAt);
                    nfce.productsValue = parseFloat(nfce.productsValue);
                    nfce.value = parseFloat(nfce.value);
                });
                Object.values(dailyReport.totalByCfop).forEach(cfop => {
                    cfop.products = parseFloat(cfop.products);
                    cfop.withDiscount = parseFloat(cfop.withDiscount);
                })
            })
            state.reports = values;
        }
    }
}
